var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h4',{staticStyle:{"line-height":"1.5"}},[_vm._v("Services \\ Bookkeeping \\ Backstaff ")]),_c('iframe',{staticClass:"iframe-wrapper",staticStyle:{"margin-top":"20px"},attrs:{"src":"https://20738444.hs-sites.com/backstaff-bookkeeper-pricing-0","frameborder":"0","id":"marketplace-backstaff"}})])
}]

export { render, staticRenderFns }